<app-control-wrapper [control]="control" [errors]="errors" [helper]="helper">
  <label control-label [attr.for]="controlId">{{ entityIdentifierLabel | translate }}</label>

  <input
    *ngIf="showHiddenControl"
    [attr.disabled]="isDisabled ? '' : null"
    type="text"
    [formControl]="hiddenControl"
    class="form-control"
    [id]="controlId + 'Hidden'"
    name="identifier"
    control-wrapper
    (focus)="showControl(true)"
  />
  <input
    *ngIf="!showHiddenControl"
    [attr.disabled]="isDisabled ? '' : null"
    type="text"
    [formControl]="control"
    class="form-control"
    [id]="controlId"
    name="identifier"
    [attr.inputmode]="itemMask.inputmode === 'numeric' ? 'numeric' : 'text'"
    [placeholder]="itemMask.placeholder || ''"
    [mask]="itemMask.mask"
    [appMaskErrorTooltip]="itemMask.maskErrorTooltip"
    [maxMaskLength]="itemMask.maskMaxLength"
    (blur)="hideControl()"
    control-wrapper
  />
</app-control-wrapper>
